export default __webpack_public_path__ + "static/media/imagePlaceholder.efa80a5f.svg";